export default {
  en: {
    TARGET_REFERENCES_TABLE_TYPE: 'Type',
    TARGET_REFERENCES_TABLE_NAME: 'Name',
    TARGET_REFERENCES_TABLE_ID: 'Reference ID',
    TARGET_REFERENCES_LOADING: 'Loading References',
    TARGET_REFERENCES_EMPTY: 'This target does not have any references',
    TARGET_DUPLICATE_SETTINGS_TITLE: 'Restrict Duplicate Calls Settings',
    TARGET_DUPLICATE_SETTINGS_TITLE_TT: 'Configure how the target will behave with duplicate calls',
    DUPLICATE_SETTINGS_OPTIONS: 'Restrict Duplicate',
    DUPLICATE_SETTINGS_OPTIONS_TT: 'Configure how the target will respond to duplicate calls',
    DUPLICATE_RESTRICTION_DURATION: 'Duration',
    DUPLICATE_RESTRICTION_DURATION_TT: 'How long duplicate calls should be blocked after the last connected or converted call',
    RESTRICT_ON: 'Restrict After',
    RESTRICT_ON_TT: 'If toggled, only previously converted and connected calls will be used for restricting duplicate calls.',
    MULTIPLE_TOGGLE_OPTIONS_BUYER_SETTINGS: 'Buyer Settings',
    MULTIPLE_TOGGLE_OPTIONS_CAMPIGN_TARGET: 'By Campaign - Individual Target',
    MULTIPLE_TOGGLE_OPTIONS_CAMPIGN: 'By Campaign - All Targets',
    MULTIPLE_TOGGLE_OPTIONS_NO_RESTRICT: 'Do not Restrict',
  }
};